<template>
  <Layout style="background: #21343b">
    <h3 v-if="userInfo" slot="title" class="big text-center mb-5" style="color: white">
      {{ $t('guestSignUpTitle') }}{{ userDisplayName }}?
    </h3>
    <v-container class="pl-0 pr-0" slot="content">
      <v-row v-if="userInfo" align="center" justify="center">
        <v-col cols="12" class="" align-self="center" align="center">
          <v-avatar
            :color="userInfo.userDisplayName || userInfo.userFullName | iconBackground"
            class="logo"
            round
            size="80"
            style="cursor: pointer"
          >
            <span
              v-if="!userInfo.userPicture"
              style="color: #ffffff; font-size: 25px; text-align: center; font-weight: bold"
            >
              {{ userInfo.userDisplayName || userInfo.userFullName | iconFilter }}
            </span>
            <v-img :src="userInfo.userPicture" v-else />
          </v-avatar>
        </v-col>
        <v-col cols="12" class="mb-10" align-self="center" align="center">
          <span style="color: #eee; font-size: 18px">{{ userInfo.userDisplayName }}</span>
        </v-col>
        <v-col cols="auto" align="center" align-self="center">
          <v-btn dark class="mr-2 white1--text" color="#6c6c6c" style="width: 180px" @click="guestSignOut">
            {{ $t('no') }}
          </v-btn>
        </v-col>
        <v-col cols="auto" align="center" align-self="center">
          <!-- <v-btn
            @click="$router.push({ name: 'SignUp' }).catch(() => {})"
            class="white1--text"
            color="#289067"
            style="width: 180px"
          >
            {{ $t('yes') }}
          </v-btn> -->
          <!-- SignIn / SignUp 통일로 SignIn 으로 이동 -->
          <v-btn
            @click="$router.push({ name: 'SignIn' }).catch(() => {})"
            class="white1--text"
            color="#289067"
            style="width: 180px"
          >
            {{ $t('yes') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <loading-dialog :isLoading="isLoading"></loading-dialog>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
// import firebase from 'firebase/app'
import LoadingDialog from './modal/LoadingDialog'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'GuestSignUp',
  components: {
    Layout,
    LoadingDialog,
  },
  data: () => ({
    isLoading: false,
  }),
  async created() {
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '게스트 회원가입',
        firebase_screen_class: 'GuestSignUp',
      },
    })
  },
  methods: {
    ...mapActions(['setSignOut']),
    guestSignOut() {
      this.setSignOut()
      // this.$router.push({ name: 'SignUp' }).catch(() => {})
      this.$router.push({ name: 'SignIn' }).catch(() => {})
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
    }),
    userDisplayName() {
      return this.userInfo && this.userInfo.userDisplayName ? this.userInfo.userDisplayName : ''
    },
  },
}
</script>
